import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { THEME_MESSAGES } from 'utils/constants';
import { getPaymentDiscrepancyLogStats } from 'api/admin/paymentDiscrepancyLogs/paymentDiscrepancyLogs';
import { ApiError } from 'types/api';

export interface PaymentDiscrepancyLogStats {
  week: { current: number; previous: number };
  month: { current: number; previous: number };
  openCount: number;
}

interface GetPaymentDiscrepancyLogStatsOutput {
  success: boolean;
  stats: PaymentDiscrepancyLogStats;
}

export const usePaymentDiscrepancyLogStats = () => {
  return useQuery<unknown, ApiError, PaymentDiscrepancyLogStats>({
    queryKey: ['paymentDiscrepancyLogStats'],
    queryFn: async () => {
      const { data } =
        (await getPaymentDiscrepancyLogStats()) as AxiosResponse<GetPaymentDiscrepancyLogStatsOutput>;

      return data.stats;
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(error?.response?.data?.error ?? THEME_MESSAGES.somethingWrong, {
        duration: 4000,
      });
    },
  });
};
